import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Centre} from '../models/centre';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/centre';

@Injectable()
export class CentresService {
  constructor(private http: HttpClient) {
  }

  getAll(): Observable<any> {
    const url = `${apiUrl}`;
    return this.http.get<any>(url);
  }

  create(centre: Centre) {
    return this.http.post<Centre>(apiUrl, centre, httpOptions);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<Centre>(url, httpOptions);
  }


  getAllGovernments() {
    const url = `assets/data/tunisaGouverments.json`;
    return this.http.get<any>(url);
  }
}
